import { DateRange, ViewFilterInput } from 'types/graphql'

export type InsightsSectionProps = {
  dateRange: DateRange
  filters: ViewFilterInput[]
  areFiltersValid: boolean
}

export type InsightsSectionWithRecordTemplateNamesProps = InsightsSectionProps & {
  recordTemplateNames: string[]
}

export enum InsightsPageType {
  AutoCheck = 'AutoCheck',
  Community = 'Community',
  Inspections = 'Inspections',
  Overview = 'Overview',
}
